export const PropertiesActionTypes = {
    SET_CURRENT_PROPERTIES : 'SET_CURRENT_PROPERTIES'
}